export default __webpack_public_path__ + "static/media/setting.fef2b799.png";